export function normalizeNumericField(
  value: number | string | null | undefined
): number | null {
  if (value == null || value === '') return null;
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;

  const parsed = parseFloat(String(value).trim());
  return Number.isFinite(parsed) ? parsed : null;
}
